export const REGIONS = [
  "--Filter by Region--",
  "Africa",
  "Americas",
  "Asia",
  "Europe",
  "Oceania",
];
